import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DelegatedDomainValidation as SchemaDelegatedDomainValidation } from '../schemas/DelegatedDomainValidation';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary Валидация возможности создания делегированного домена
 */
export const ValidateDelegatedDomainContentType = 'application/json' as const;
export type ValidateDelegatedDomainRequest = {
    /**
     * @example example.ru
     */
    domain: string;
};
export type ValidateDelegatedDomainResponses = LinkCommonErrorResponses & {
    /**
     * @description Результат валидации возможности создания делегированного домена
     */
    '200': {
        'application/json': SchemaDelegatedDomainValidation;
    };
};
export type ValidateDelegatedDomainResponseSuccess = ValidateDelegatedDomainResponses['200']['application/json'];
export type ValidateDelegatedDomainSearchParams = undefined;
export type ValidateDelegatedDomainPathParameters = undefined;
export const ValidateDelegatedDomainUrl = '/awacs/domain/validate-delegation' as const;
export const ValidateDelegatedDomainMethod = 'POST' as const;
export const getValidateDelegatedDomainUrl = (_params?: ValidateDelegatedDomainPathParameters) =>
    ValidateDelegatedDomainUrl;
